const ContactForm = () => {
    const handleSubmit = (e) => {
        e.preventDefault();

        const name = e.target.elements.name.value;
        const email = e.target.elements.email.value;
        const message = e.target.elements.message.value;

        const mailtoLink =
            `mailto:zubaidesign@gmail.com?subject=New Contact from ${name}` +
            `&body=Name: ${name}%0AEmail: ${email}%0A%0A${message}`;

        window.location.href = mailtoLink;
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Your Name..." required />
            <input type="email" name="email" placeholder="Your Email Address..." required />
            <textarea name="message" placeholder="Your Message..." rows="4" required />
            <button type="submit">SUBMIT</button>
        </form>
    );
};

export default ContactForm;
